import { trackError } from 'helpers/track_error';
import type { TofuSurveyQuestionsType } from 'packages/signup/components/TofuSurvey';
import type { CompanyLeadPayload } from 'packages/signup/components/signupForm/types';
import removePIIFromCompanyLeadPayload from 'packages/signup/analytics/removePIIFromCompanyLeadPayload';

const trackSurveySignupAnswerSubmittedAndFailed = (
  companyLead: CompanyLeadPayload,
  surveyAnswers: TofuSurveyQuestionsType,
  status: string,
  responseText: string
) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupAnswerSubmittedAndFailed',
    data: {
      company_lead: removePIIFromCompanyLeadPayload(companyLead),
      survey_answer: surveyAnswers,
      status,
    },
  });

  trackError({
    error: new Error(`[SurveySignupModal] Failed with status: ${status}`),
    custom: {
      message: responseText,
    },
  });
};

export default trackSurveySignupAnswerSubmittedAndFailed;
